import { useBootstrap } from '../context/BootstrapContext'

export function useGallery() {
  const { data, loading } = useBootstrap()
  return { photos: data.gallery, loading }
}
